import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Breadcrumb from '../../components/breadcrumb/Breadcrumb';
import Card from '../../components/Cards/Card';
import MainContainer from "../../components/container/MainContainer";
import CustomButton from '../../components/CustomButton/CustomButton';
import { getDetails } from '../../services/http/http.service';
import { getUserDetails } from '../../store/authentication/authentication.actions';
import { hideLoader, showLoader } from '../../store/Loader/loader.slice';
import { useAppDispatch, useAppSelector } from '../../store/storeRequests';
import APIList from '../../utils/constants/APIList';
import BreadcrumbData from '../../utils/constants/BreadcrumbData.constants';
import { APIResponseCodes } from '../../utils/constants/keys.constants';
import StoreSelectors from '../../utils/constants/StoreSelectors.constants';
import encrypt from '../../utils/helpers/encrypt';
import './checkout.css';
import { NavList } from '../../utils/constants/navigation';
import { message } from '../../utils/constants/Messages';

const Checkout: React.FunctionComponent<any> = () => {

  const isUIMounted = useRef(false)
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const { access } = useAppSelector(StoreSelectors.USER_STATE)

  const [allAPIs, setAllAPIs] = useState([] as Array<any>)
  const [disableProceed, setDisableProceed] = useState(true)

  const getData = async () => {

    dispatch(showLoader(message.GETTING_CHECKOUT_CART))
    const response = await getDetails(APIList.GET_ALL_PROD_CART_ITEMS, getData)

    if (response.statusCode === APIResponseCodes.SUCCESS) {
      const temp: Array<any> = []
      if (response.data.api_list.length !== 0) {
        response.data.api_list.forEach((api: any) => {
          // const versionInfo = response.data.api_ver_id_list.find(
          //   (ver: any) => ver.group_version_id === api.group_version_id
          // );
          // const legalApproved = response.data.info.some((item: any) => {
          //   if (item.name.toLowerCase() === api.group_type.toLowerCase()) {
          //     return item.path.length !== 0;
          //   }
          //   return false;
          // });
          //For now we are skipping legal and agreement page so directly setting legal and commercial approved to true
           //For now we are skipping legal and agreement page so directly setting legal and commercial approved to true
          // so that directly purchase can be done from checkout page. Once legal and agreement page is implemented then we can uncomment below code and remove the direct true assignment.
          // temp.push({
          //   ...api,
          //   legal_approved: legalApproved,
          //   commercial_approved: versionInfo ? versionInfo.agree : false,
          // });
          temp.push({
            ...api,
            legal_approved: true, //directly set legal approved to true as we are skipping legal and agreement page
            commercial_approved: true, //directly set commercial approved to true as we are skipping legal and agreement page
          });
        });
      }
      setAllAPIs(temp)
      const disableBtn = temp.some(api => !(api.legal_approved && api.commercial_approved));
      setDisableProceed(disableBtn)
      dispatch(hideLoader())

    } else {
      dispatch(hideLoader())
    }

  }

  useEffect(() => {
    if (access.hasProdAccess) {
      isUIMounted.current = false
    }

    if (isUIMounted.current === true || !access.hasProdAccess) return
    getData()
    isUIMounted.current = true
  }, [access])

  const placeOrder = async () => {
    dispatch(showLoader(message.PLACE_ORDER))
    try {
      const response = await getDetails(APIList.PLACE_PROD_ORDER, placeOrder)
      dispatch(hideLoader())
      if (response.statusCode === APIResponseCodes.SUCCESS) {
        navigate(`${NavList.ORDER_DETAILS}${encodeURIComponent(encrypt(response.data.orderId))}}`)
        sessionStorage.clear()
        dispatch(getUserDetails())
      }

      dispatch(hideLoader())
    } catch (error) {
      dispatch(hideLoader())
      console.log(error)
    }
  }


  return (
    <MainContainer>
      <Breadcrumb routes={BreadcrumbData.checkout} />
      <h2 className='text-capitalize mf-active-header'>Checkout</h2>

      {
        allAPIs.length !== 0 ?
          <div className="checkout-container">
            <Card list={allAPIs} from='checkout' callbackFunction={getData} />
            <div className="button-width-container mx-auto mb-5">
              <CustomButton disabled={disableProceed} onClick={placeOrder}>Proceed</CustomButton>
            </div>
          </div>
          :
          <div className="text-center py-3 no-data-with-view">
            <p className="mb-0 weight-500 font-14 text-primary-color mb-2">No APIs added to cart for checkout...</p>
            <button onClick={() => navigate(NavList.API_LISTING_PRODUCTION)} className="border-0 font-13 text-sec-color weight-500">View approved APIs {'>'}</button>
          </div>
      }

    </MainContainer>
  )
}

export default Checkout
